import React from 'react';
import { Alert, Card, CardGroup, Checkbox } from '@ver-uds/uswds-react';
import { MouTemplateType } from 'eve-account-client';
import Section from '../../Section';
import EvePlusTermsOfService from './EvePlusTermsOfService';
import EveTermsOfUse from './EveTermsOfUse';
import { AuthFileLinkProps } from '../../AuthFileLink';

export type MouLinkType = MouTemplateType | string;

export interface TermsAndConditionsProps {
  // eslint-disable-next-line @typescript-eslint/ban-types
  register: Function;
  setHasUserReadTermsOfService: React.Dispatch<React.SetStateAction<boolean>>;
  isCorporateAccountSelected: boolean;
  hideEvePlusToS: boolean;
  linkToMou?: React.ReactElement<AuthFileLinkProps<MouLinkType>>;
  nawToAawToggle: string;
}

const TermsAndConditions = ({
  register,
  setHasUserReadTermsOfService,
  isCorporateAccountSelected,
  hideEvePlusToS,
  linkToMou,
  nawToAawToggle,
}: TermsAndConditionsProps): JSX.Element => {
  const pageTitle = 'Terms and Conditions';

  const handleScroll = (e: React.UIEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    const bottom = target?.scrollHeight - target?.scrollTop <= target?.clientHeight + 10;
    if (bottom) {
      setHasUserReadTermsOfService(true);
    }
  };

  return (
    <Section title={pageTitle} data-testid="terms-and-conditions" className="margin-bottom-0">
      <Alert status="warning" className="margin-y-3" slim>
        <Alert.Text>
          You must agree to Terms of Use {!hideEvePlusToS && <>and Terms of Service policies</>} in order to enroll in
          E-Verify.
        </Alert.Text>
      </Alert>
      <CardGroup>
        <Card>
          <Card.Header as="h3">E-Verify Terms of Use</Card.Header>
          <Card.Body>
            <EveTermsOfUse isCorporateAccountSelected={isCorporateAccountSelected} linkToMou={linkToMou} />
          </Card.Body>
          <Card.Footer>
            <Checkbox
              id="iAgreeCheckbox"
              data-testid="i-agree-checkbox"
              name="iAgreeCheckbox"
              label="I agree to the E-Verify Terms of Use"
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              ref={register({ required: { value: true } })}
            />
          </Card.Footer>
        </Card>
        {!hideEvePlusToS ? (
          <Card>
            <Card.Header as="h3">E-Verify+ Terms of Service</Card.Header>
            <Card.Body>
              <div
                className="height-mobile overflow-y-scroll"
                onScroll={handleScroll}
                data-testid="eve-plus-tos-container"
              >
                <EvePlusTermsOfService nawToAawToggle={nawToAawToggle} />
              </div>
            </Card.Body>
            <Card.Footer>
              <Checkbox
                id="iAgreeCheckboxEvePlus"
                data-testid="i-agree-checkbox-eve-plus"
                name="iAgreeCheckboxEvePlus"
                label="I agree to the E-Verify+ Terms of Service"
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                ref={register({ required: { value: true } })}
              />
            </Card.Footer>
          </Card>
        ) : (
          <></>
        )}
      </CardGroup>
    </Section>
  );
};

export default TermsAndConditions;
